import { message } from 'antd';
import { useTranslation } from 'react-i18next';

const AUTH0_ERROR_CODE = {
    invalid_password: 'errors.auth.invalidPassword',
    invalid_grant: 'errors.auth.invalidCredentials',
    invalid_request: 'errors.auth.invalidRequest',
    access_denied: 'errors.auth.accessDenied',
    unauthorized: 'errors.auth.unauthorized',
    network_error: 'errors.auth.networkError',
    server_error: 'errors.auth.serverError',
    invalid_token: 'errors.auth.invalidToken',
    password_leaked: 'errors.auth.passwordLeaked',
    too_many_attempts: 'errors.auth.tooManyAttempts',
    unsupported_grant_type: 'errors.auth.unsupportedGrant',
    invalid_signup: 'errors.auth.invalidSignup',
};
export function errorHandler(error) {
    let errMsg = 'errors.general';

    if (error?.data) {
        const {
            code,
            description,
            error_description,
            message: serverMessage,
        } = error.data;

        if (code && AUTH0_ERROR_CODE[code]) {
            errMsg = AUTH0_ERROR_CODE[code];
        } else if (error_description) {
            errMsg = error_description;
        } else if (description) {
            errMsg = description;
        } else if (serverMessage) {
            errMsg = serverMessage;
        }
    } else if (error?.message) {
        errMsg = error.message;
    }

    return errMsg;
}

export function useCheckAuthResponse() {
    const { t } = useTranslation();

    const checkAuthResponse = (
        res: any,
        type?: 'login' | 'signUp' | 'resetPassword',
        item?: string
    ) => {
        if (res?.access_token) {
            message.success({
                content: t(`notification.success.${type}`),
                className: 'response-success',
                type: 'success',
            });
            return { success: true, data: res.data };
        }

        if (type === 'resetPassword' && res?.status !== 400) {
            message.success({
                content: t('notification.success.resetPassword'),
                className: 'response-success',
                type: 'success',
            });
            return { success: true };
        }

        if (type === 'signUp' && res?.status >= 200 && res?.status < 300) {
            message.success({
                content: t('notification.success.signUp'),
                className: 'response-success',
                type: 'success',
            });
            return { success: true };
        }

        // Handle errors properly
        if (res?.status && res.status >= 400) {
            message.error({
                content: t(errorHandler(res)),
                className: 'response-error',
                type: 'error',
            });
            return { success: false, data: null };
        }

        return { success: false, data: null };
    };
    return {
        checkAuthResponse,
        t,
    };
}
